import { render, staticRenderFns } from "./ExcelMapperSettingsEditUploadFile.vue?vue&type=template&id=4884e8ba&scoped=true"
import script from "./ExcelMapperSettingsEditUploadFile.vue?vue&type=script&lang=ts"
export * from "./ExcelMapperSettingsEditUploadFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884e8ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4884e8ba')) {
      api.createRecord('4884e8ba', component.options)
    } else {
      api.reload('4884e8ba', component.options)
    }
    module.hot.accept("./ExcelMapperSettingsEditUploadFile.vue?vue&type=template&id=4884e8ba&scoped=true", function () {
      api.rerender('4884e8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/excel-mapper/ExcelMapperSettingsEditUploadFile.vue"
export default component.exports